<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>配置管理</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div>
          <Button type="primary" icon="plus" @click="toAddConfig" v-if="authList.indexOf('004001') !== -1">添加</Button>
          <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('004003') !== -1">删除</Button>
          <Button type="info" icon="cube" @click="showCodeImg">生成二维码</Button>
        </div>
        <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="配置名" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
      </div>

      <Table border height="520" ref="user_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除配置？</p>
    </Modal>

    <Modal
      v-model="codeBox"
      title="二维码"
      @on-ok="closeCodeBox">
      <div id="qrcode" class="code"></div>
      <div slot="footer">
        <i-button type="primary"  @click="closeCodeBox">确定</i-button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import TopOpe from '../top-ope/top-ope'
import {nError, nSuccess} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'
import QRCode from 'qrcodejs2'
import {getAuthStr} from '../../util/bus'

export default {
  authList: '',
  components: {TopOpe},
  name: 'config-management',
  data () {
    return {
      openSimple: false,
      codeBox: false,
      reqbody: {
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      columns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '配置名',
        key: 'configName',
        align: 'center'
      }, {
        title: '开门记录url',
        key: 'openDoorRecordUrl',
        align: 'center'
      }, {
        title: '报警记录url',
        key: 'alarmRecordUrl',
        align: 'center'
      }, {
        title: '心跳url',
        key: 'heartBeatUrl',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createTime',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        align: 'center',
        render: (h, params) => {
          if (params.row.authStatusM && !params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyUser(params.row.id)
                  }
                }
              }, '修改')
            ])
          } else if (!params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteUser(params.row.id)
                  }
                }
              }, '删除')
            ])
          } else if (params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyUser(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteUser(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      }],
      tableData: [],
      total: 0,
      codeStr: '',
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getConfigPage()
  },
  methods: {
    toAddConfig () {
      this.$router.push({
        path: '/add_config'
      })
    },
    getConfigPage () {
      this.$axios.post(`${httpUrl.url}/manage/config/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (this.authList.indexOf('004004') !== -1) {
              data.list.map(v => {
                v.authStatusM = true
              })
            } else {
              data.list.map(v => {
                v.authStatusM = false
              })
            }
            if (this.authList.indexOf('004003') !== -1) {
              data.list.map(v => {
                v.authStatusD = true
              })
            } else {
              data.list.map(v => {
                v.authStatusD = false
              })
            }
            data.list.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              } else {
                v.createTime = '--'
              }
            })
            this.tableData = data.list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    modifyUser (id) {
      this.$router.push({
        path: '/modify_config/' + id
      })
    },
    deleteUser (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    showCodeImg () {
      if (!this.batchId.ids) {
        nError('请先选择配置')
        return false
      }
      if (this.batchId.ids.length > 1) {
        nError('生成二维码不可多选配置')
        return false
      }
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].id === parseInt(this.batchId.ids)) {
          this.codeStr = this.tableData[i].openDoorRecordUrl + this.tableData[i].alarmRecordUrl + this.tableData[i].heartBeatUrl
        }
      }
      let codeDiv = document.getElementById('qrcode')
      codeDiv.innerHTML = ''
      this.$nextTick(() => {
        this.makeCode(this.codeStr)
        this.codeBox = true
      })
    },
    makeCode (str) {
      let qrcode = new QRCode('qrcode', {
        width: 260,
        height: 260, // 高度
        text: str // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      })
      console.log(qrcode)
    },
    closeCodeBox () {
      this.codeBox = false
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择设备')
        return false
      }
      this.deleteUser(this.batchId.ids)
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/config/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.reqbody.pageNo = 1
            this.getConfigPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getConfigPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getConfigPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getConfigPage()
    }
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
  .code {
    width: 260px;
    height: 260px;
    margin: 20px auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/config-management/config-management.vue